import {Suspense} from 'react';
import {BodySiteId, ConditionId} from '@legit-health/ui';
import {Container, Skeleton} from '@mui/material';
import BaseDiagnosticReportFormModal from '@/shared/components/diagnosticReport/DiagnosticReportFormModal';
import {UseModal} from '@/shared/hooks/useModal';
import {Encounter} from '@/shared/interfaces/Encounter';
import ModalContent from './ModalContent';
import ModalTitle from './ModalTitle';

export default function DiagnosticReportFormModal({
  modal,
  ...rest
}: {
  modal: UseModal;
  conditionId?: ConditionId | null;
  onSuccess: () => void;
  encounter?: Encounter | null;
  bodySiteId?: BodySiteId | null;
}) {
  return (
    <BaseDiagnosticReportFormModal modal={modal} title={<ModalTitle />}>
      <Suspense
        fallback={
          <Container maxWidth="xl">
            <Skeleton variant="rectangular" width="100%" height="20" sx={{mb: 1}} />
            <Skeleton variant="rectangular" width="100%" height="40" sx={{mb: 2}} />
            <Skeleton variant="rectangular" width="100%" height="20" sx={{mb: 1}} />
            <Skeleton variant="rectangular" width="100%" height="40" sx={{mb: 2}} />
          </Container>
        }
      >
        <ModalContent {...rest} />
      </Suspense>
    </BaseDiagnosticReportFormModal>
  );
}
